import { render, staticRenderFns } from "./EdicionCupones.vue?vue&type=template&id=995044e4&"
import script from "./EdicionCupones.vue?vue&type=script&lang=js&"
export * from "./EdicionCupones.vue?vue&type=script&lang=js&"
import style0 from "./EdicionCupones.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports